import { atom } from "jotai";

export const createdAllTeams = atom({
  createTeam: false,
  createSubTeam: false,
});

export const sectorOfficerTeamDetails = atom({});

// =========== Report ==========
export const projectIdStore = atom("");
export const villageIdStore = atom(0);
